var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',[_c('b-col',{staticClass:"pt-0 mb-3"},[(_vm.title)?_c('label',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }